const datoraErrorKeys = { empty: 'discountErrorEmpty', double: 'discountErrorDouble', failed: 'discountErrorFailed', invalid: 'discountErrorInvalid' };

const truncate = (str, len = 10) => str.length > len ? str.substring(0, len) + '...' : str;

// DATORACODE - A/B-Test (CFSN-603): true only when the hide-toggle is on, auto-discount is
// enabled, and the active code matches the configured auto_discount_code (case-insensitive,
// whitespace-trimmed) — regardless of how the code was applied (auto or manually entered).
function shouldHideAutoCode(activeCode) {
  const ts = window.themeSettings || {};
  const tv = (window.themeVariables && window.themeVariables.settings) || {};
  if (!ts.hideAutoDiscountCode || !tv.autoDiscountEnabled || !tv.autoDiscountCode) return false;
  if (!activeCode) return false;
  return activeCode.trim().toUpperCase() === String(tv.autoDiscountCode).trim().toUpperCase();
}

// Shopify-kompatible Preisformatierung
function shopifyFormatCurrency(cents, formatString) {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return '0';
    const numString = (number / 100.0).toFixed(precision);
    const parts = numString.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  return formatString.replace(placeholderRegex, (match, placeholder) => {
    switch (placeholder) {
      case 'amount':
        return formatWithDelimiters(cents, 2);
      case 'amount_no_decimals':
        return formatWithDelimiters(cents, 0);
      case 'amount_with_comma_separator':
        return formatWithDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return formatWithDelimiters(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return formatWithDelimiters(cents, 2, "'", '.');
      case 'amount_no_decimals_with_space_separator':
        return formatWithDelimiters(cents, 0, ' ');
      case 'amount_with_space_separator':
        return formatWithDelimiters(cents, 2, ' ', ',');
      case 'amount_with_period_and_space_separator':
        return formatWithDelimiters(cents, 2, ' ', '.');
      default:
        return match;
    }
  });
}

const formatPrice = function(cents) {
  return shopifyFormatCurrency(cents, window.themeVariables.settings.moneyFormat);
}

function wrapFromPrice(formattedPrice, div) {
  if (div && div.dataset.datoraPriceVaries === 'true' && window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.fromPriceHtml) {
    return window.themeVariables.strings.fromPriceHtml.replace('_PRICE_', formattedPrice);
  }
  return formattedPrice;
}

// Hilfsfunktionen für Preisanzeige (EUR mit transcy-money span vs. andere Währungen mit Textknoten)
function setPriceText(container, price) {
  const visuallyHidden = container.querySelector('.visually-hidden');

  // Alles nach dem visually-hidden span entfernen
  while (visuallyHidden && visuallyHidden.nextSibling) {
    visuallyHidden.nextSibling.remove();
  }

  // Neuen Preis einfügen (kann HTML enthalten bei EUR/Transcy)
  if (visuallyHidden) {
    visuallyHidden.insertAdjacentHTML('afterend', price);
  } else {
    container.innerHTML = price;
  }
}

const applyDatoraDiscount = async function() {
  const datoraInput = document.querySelector('input[name="datora-discount"][form="datora-form"]') ||
                     document.querySelector('input[name="datora-discount"]');
  if(!datoraInput) return;
  const discountCode = datoraInput.value.trim();
  if(discountCode.length < 1){
    errorDatoraDiscount('show', 'empty');
    return;
  }
  const datoraContainer = datoraInput.closest('.datora-discount-field-container');
  errorDatoraDiscount('hide');
  if(datoraContainer) datoraContainer.classList.add('loading');

  if (typeof co2 === 'undefined') {
    if(datoraContainer) datoraContainer.classList.remove('loading');
    return;
  }

  const cleanInput = discountCode.trim().toUpperCase();
  const getCurrentDiscountCode = await co2.getDiscountCode();
  if(getCurrentDiscountCode && getCurrentDiscountCode.trim().toUpperCase() === cleanInput){
    if(datoraContainer) datoraContainer.classList.remove('loading');
    errorDatoraDiscount('show', 'double', discountCode);
    return;
  }

  const resultChangeDiscountCode = await co2.setDiscountCode(discountCode);
  if(resultChangeDiscountCode){
    refreshCartAndPrices();
    if (typeof restoreDiscountState === 'function') restoreDiscountState();
  } else {
    errorDatoraDiscount('show', 'failed', discountCode);
  }
  if(datoraContainer) datoraContainer.classList.remove('loading');
};

const removeDatoraDiscount = async function() {
  errorDatoraDiscount('hide');
  const datoraContainer = document.querySelector('.datora-discount-field-container');
  if(datoraContainer) datoraContainer.classList.add('loading');

  if (typeof co2 === 'undefined') {
    if(datoraContainer) datoraContainer.classList.remove('loading');
    return;
  }

  const resultRemoveDiscountCode = await co2.removeDiscountCode();
  if(resultRemoveDiscountCode){
    refreshCartAndPrices();
    document.querySelectorAll('.discounted[data-datora-price]').forEach(div => {
      resetProductGridDiscount(div);
    });
  }
  if(datoraContainer) datoraContainer.classList.remove('loading');
}

function setDatoraClasses(parentElem, fakeComparePrice) {
  const compare = parentElem.querySelector('.price-list .price--compare');
  if (compare && typeof setPriceText === 'function') {
    compare.classList.remove('hidden');
    setPriceText(compare, fakeComparePrice);
  }
}

// DATORACODE - A/B-Test (CFSN-620): Preisdarstellungs-Variante pro Element aus den Liquid-Klassen lesen —
// nur Opt-in-Flächen (PDP, Card, Predictive Search) tragen price--v620-*; alle anderen laufen den Standard-Pfad
function getAbPriceDisplayFor(div) {
  if (div.classList.contains('price--v620-inline')) return 'compare_inline';
  if (div.classList.contains('price--v620-twoline')) return 'compare_two_line';
  return 'standard';
}

// DATORACODE - A/B-Test (CFSN-620): Sale-Prozent aus dem Liquid-Attribut (identische Rundung in allen Kontexten);
// Fallback-Berechnung nur, falls das Attribut fehlt
function getSalePct(div) {
  const pct = parseInt(div.dataset.datoraSalePct || '', 10);
  if (!isNaN(pct)) return pct;
  const price = Number(div.dataset.datoraPrice);
  const compare = Number(div.dataset.datoraCompare || 0);
  // DATORACODE - A/B-Test (CFSN-620): gleiche Operationsreihenfolge wie Liquid ((C-P)*100/C) für identische Rundung
  return compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
}

// DATORACODE - A/B-Test (CFSN-620): Badge-Text für B/C — nie mit Code-Name.
// B + Sale (Fall 3) kombiniert Sale-Prozent und Rabatt-Wert:
//   plus: -40% + 10% / -40% + €1,99 (Minus nur vor dem ersten Wert)
//   amp:  -40% & -10% / -40% & -€1,99 (Minus vor beiden Werten)
// Bei 0% Sale-Anteil (oder Variante C / Fall 4) nur der Rabatt-Wert.
function buildAbBadgeText(div, abDisplay, saleLayout, discStr) {
  const salePct = saleLayout ? getSalePct(div) : 0;
  if (abDisplay !== 'compare_inline' || salePct < 1) {
    return `<b>-${discStr}</b>`;
  }
  const fmt = window.themeSettings && window.themeSettings.abCfsn620PriceCombinedFormat;
  return fmt === 'amp'
    ? `<b>-${salePct}% &amp; -${discStr}</b>`
    : `<b>-${salePct}% + ${discStr}</b>`;
}

function errorDatoraDiscount(type = 'show', reason = 'invalid', code = '') {
  const cartDrawer = document.querySelector('cart-drawer');
  const datoraContainer = document.querySelector('.datora-discount-field-container');
  const errorDiv = datoraContainer ? datoraContainer.querySelector('.datora-discount-error') : null;
  if(type == "show"){
    let errorAlert = window.themeVariables?.strings?.[datoraErrorKeys[reason]] ?? false;
    if(!errorAlert) return;
    const cleanCode = code.trim().toUpperCase();
    errorAlert = errorAlert.replace("[[CODE]]",truncate(cleanCode,10));
    if(datoraContainer) datoraContainer.classList.add('error');
    if(errorDiv) errorDiv.style.display = 'block';
    if(reason == "empty"){
      if(datoraContainer) datoraContainer.querySelector('.datora-input input').focus();
    }else if(reason == "double" || reason == "invalid" || reason == "failed"){
      if(datoraContainer){
        const input = datoraContainer.querySelector('.datora-input input');
        const isActive = datoraContainer.getAttribute('data-discount-state') === 'active';
        if(isActive){
          if(typeof restoreDiscountState === 'function') restoreDiscountState();
        }else{
          input.value = '';
          input.classList.remove('is-filled');
        }
      }
    }
    if(datoraContainer) datoraContainer.querySelector('.datora-discount-error span').innerHTML = errorAlert;
  }else{
    if(cartDrawer) cartDrawer.classList.remove('error');
    if(datoraContainer) datoraContainer.classList.remove('error');
    if(errorDiv) errorDiv.style.display = '';
  }
}


// DATORACODE - CFSN-568 A/B-Test: Bild-Mirror-Slot zum Price-Badge-Host finden (Card / PDP / Cart-Upsell-Slider)
function getImageDiscountMirror(div){
  const root = div.closest('.product-card-wrapper, product-info, .simple-upsell__card, .stl-card');
  return root ? root.querySelector('[data-datora-image-mirror]') : null;
}

function resetProductGridDiscount(div){
  div.classList.remove('discounted');
  div.classList.remove('price--datora-loading');
  const oldPrice = div.dataset.datoraPrice;
  const oldCompare = div.dataset.datoraCompare;
  const oldCompareCheck = (oldCompare && oldCompare != "") ? parseInt(oldCompare) : 0;
  // DATORACODE - A/B-Test (CFSN-620): B/C setzen den Compare-Span immer in den Ausgangszustand (hidden) zurück —
  // die Streichpreis-Darstellung ohne Rabatt gehört dort dem Liquid-Markup (.price__sale)
  if (getAbPriceDisplayFor(div) !== 'standard') {
    const compare = div.querySelector('.price--compare');
    if (compare) compare.classList.add('hidden');
  } else if(oldCompareCheck == 0){
    const compare = div.querySelector('.price--compare');
    if (compare) compare.classList.add('hidden');
  }
  const basePriceFormatted = wrapFromPrice(formatPrice(oldPrice), div);
  const priceContainer = div.querySelector('.price-list .price:not(.price--compare)');
  if (priceContainer && typeof setPriceText === 'function') {
    setPriceText(priceContainer, basePriceFormatted);
  }
  const datoraInfo = div.querySelector('[data-datora]');
  if (datoraInfo) datoraInfo.textContent = '';
  const badge = div.querySelector('.datora.discount-badge');
  if (badge) badge.setAttribute('hidden', true);
  // DATORACODE - CFSN-568 A/B-Test: Bild-Mirror zurücksetzen
  const imageMirror = getImageDiscountMirror(div);
  if (imageMirror) {
    imageMirror.textContent = '';
    imageMirror.setAttribute('hidden', true);
  }
}

async function updateProductGridDiscounts(scope) {
  scope = scope || document;

  // DATORACODE - CFSN-664 A/B-Test: eigener Lauf, unabhängig vom Rabattcode-Gate unten
  if (typeof observeCardTierBadges === 'function') observeCardTierBadges(scope);

  const discountCode = await co2.getDiscountCode();
  if (!discountCode) {
    scope.querySelectorAll('[data-datora-product-id]').forEach(function (el) {
      el.classList.remove('price--datora-loading');
      resetProductGridDiscount(el);
    });
    // DATORACODE - CFSN-664: Mirror kann sich hier auf "aus" gedreht haben (Rabattcode entfernt) —
    // bereits gezeigte Staffel-Badges neu bewerten, sonst bleibt ein zu Unrecht verstecktes/gezeigtes Badge stehen.
    // Scope-begrenzt auf den hier verarbeiteten Ausschnitt (siehe recomputeCardTierBadges).
    if (typeof recomputeCardTierBadges === 'function') recomputeCardTierBadges(scope);
    return;
  }

  for (const div of scope.querySelectorAll('[data-datora-product-id]')) {
    const vid = div.dataset.datoraVariantId;
    const pid = div.dataset.datoraProductId;
    const tags = div.dataset.datoraTags;
    const price = div.dataset.datoraPrice;
    const onSale = div.dataset.datoraSalePrice === 'true';

    if (!(vid && pid && price)) {
      div.classList.remove('price--datora-loading');
      continue;
    }

    try {
      const data = await co2.itemDiscountFull(Number(pid), Number(vid), tags ? tags.split(',') : [], Number(price), 1, false, onSale);
      div.classList.remove('price--datora-loading');

      if (!data) {
        resetProductGridDiscount(div);
        continue;
      }

      let validDisc = false;
      let newPrice, badgeText, imageBadgeText;

      /* DATORACODE - Compact-Flag: Badge ohne Rabattcode wenn data-datora-compact="true" */
      const compact = div.dataset.datoraCompact === 'true';

      // DATORACODE - A/B-Test (CFSN-620): Layout-Fall aus der Root-Klasse — price--on-sale bedeutet
      // "Sale und kein Volume-Pricing" (von Liquid berechnet, in B/C ohne hide_compare_prices-Gate)
      const abDisplay = getAbPriceDisplayFor(div);
      const saleLayout = abDisplay !== 'standard' && div.classList.contains('price--on-sale');

      if (data.calc === "perc" && data.discPerc > 0) {
        validDisc = true;
        newPrice = formatPrice(data.discPrice);
        // DATORACODE - CFSN-568: Bild-Badge immer kompakt (ohne Code), unabhängig vom Preis-Badge
        imageBadgeText = `<b>-${data.discPerc}%</b>`;
        if (abDisplay === 'standard') {
          badgeText = compact
            ? imageBadgeText
            : `<b>-${data.discPerc}%</b> (${discountCode.toUpperCase()})`;
        } else {
          // DATORACODE - A/B-Test (CFSN-620): B/C — Badge ohne Code-Name, in B Fall 3 kombiniert
          badgeText = buildAbBadgeText(div, abDisplay, saleLayout, `${data.discPerc}%`);
        }
      } else if (data.calc === "amt" && data.discAmt > 0) {
        validDisc = true;
        newPrice = formatPrice(data.discPrice);
        const discountValue = price - data.discPrice;
        imageBadgeText = `-${formatPrice(discountValue)}`;
        if (abDisplay === 'standard') {
          badgeText = compact
            ? imageBadgeText
            : `-${formatPrice(discountValue)} | ${discountCode.toUpperCase()}`;
        } else {
          badgeText = buildAbBadgeText(div, abDisplay, saleLayout, formatPrice(discountValue));
        }
      }

      if (validDisc) {
        div.classList.add('discounted');
        const priceContainer = div.querySelector('.price-list .price:not(.price--compare)');
        if (priceContainer && typeof setPriceText === 'function') {
          setPriceText(priceContainer, wrapFromPrice(newPrice, div));
        }
        if (abDisplay === 'compare_two_line' && saleLayout) {
          // DATORACODE - A/B-Test (CFSN-620): C Fall 3 — beide Streichpreise leben in Zeile 1 (.price__sale);
          // Compare-Span versteckt lassen (Guard gegen einen vorherigen Fall-4-Zustand nach Swatch-Wechsel)
          const compareEl = div.querySelector('.price-list .price--compare');
          if (compareEl) compareEl.classList.add('hidden');
        } else if (abDisplay === 'compare_inline' && saleLayout) {
          // DATORACODE - A/B-Test (CFSN-620): B Fall 3 — Streichpreis ist der compare_at-Preis statt des Originalpreises
          setDatoraClasses(div, formatPrice(Number(div.dataset.datoraCompare)));
        } else {
          const originalPriceAsComparePrice = formatPrice(price);
          setDatoraClasses(div, originalPriceAsComparePrice);
        }
        const datoraBadge = div.querySelector('[data-datora]');
        if (datoraBadge) datoraBadge.innerHTML = badgeText;
        const badge = div.querySelector('.datora.discount-badge');
        if (badge) badge.removeAttribute('hidden');
        // DATORACODE - CFSN-568 A/B-Test: gleichen Badge-Text aufs Produktbild spiegeln (kein zweiter API-Call)
        const imageMirror = getImageDiscountMirror(div);
        if (imageMirror) {
          imageMirror.innerHTML = imageBadgeText;
          imageMirror.removeAttribute('hidden');
        }
      } else {
        resetProductGridDiscount(div);
      }
    } catch (error) {
      console.error('[datora] discount error:', error);
      div.classList.remove('price--datora-loading');
      resetProductGridDiscount(div);
    }
  }

  // DATORACODE - CFSN-664: zentral hier statt bei jedem Aufrufer einzeln — observeCardTierBadges()
  // oben kann den Staffel-Badge per IntersectionObserver zeigen, BEVOR der Bild-Discount-Mirror
  // (oben in der Schleife) aktiv gesetzt wird (Race). Erst nach Abschluss der Schleife ist der
  // Mirror-Zustand aller Karten final — jetzt jede bereits berechnete Karte neu bewerten, damit ein
  // zu Unrecht gezeigter Staffel-Badge (Prioritäts-Verletzung) wieder verschwindet. Scope-begrenzt
  // auf den hier verarbeiteten Ausschnitt, sonst loest z.B. ein einzelner Swatch-Wechsel eine
  // seitenweite Neuberechnung aus.
  if (typeof recomputeCardTierBadges === 'function') recomputeCardTierBadges(scope);
}

// ---------------------------------------------------------------------------
// DATORACODE - CFSN-664 A/B-Test: Staffelpreis-Badge/-Zeile auf der Produktkarte
// ---------------------------------------------------------------------------

// Geteilte Tier-Logik (PDP + Karte) — 1:1 aus tiered-pricing-pdp.js extrahiert, damit beide
// Flaechen nicht auseinanderlaufen. variantTags: Array aus co2.variant_tags.
async function computeCo2Tiers(productId, variantId, productTags, priceCents, compareAtPriceCents, variantTags) {
  const salePrice = compareAtPriceCents > priceCents;
  const { rule_applies = [], condition_applies = [] } =
    (await co2.conditionalDiscounts(productId, variantId, productTags, false, salePrice, variantTags)) || {};

  const byQuant = new Map();
  condition_applies
    .filter((entry) => rule_applies.includes(entry))
    .filter((entry) => entry.cond_minimum === 'quant' && entry.multi_apply === 'unlimited' && entry.disc_perc > 0)
    .forEach((entry) => {
      const existing = byQuant.get(entry.cond_quant);
      if (!existing || entry.disc_perc > existing.disc_perc) byQuant.set(entry.cond_quant, entry);
    });

  const tiers = [...byQuant.values()].sort((a, b) => a.cond_quant - b.cond_quant);
  if (!tiers.length) return [];

  const baseline = (
    await co2.itemDiscount(productId, variantId, productTags, priceCents, 1, false, salePrice, variantTags)
  ).discPrice;
  const round = (value) => Math.round(value + 1e-9); // matches the co2 engine exactly

  return tiers
    .map((entry) => ({
      quant: entry.cond_quant,
      percent: entry.disc_perc,
      unitPriceCents: round(priceCents * (1 - entry.disc_perc / 100)),
    }))
    .filter((tier) => tier.unitPriceCents < baseline);
}

// DATORACODE - CFSN-664: root kann product-info sein, das auch verschachtelte Empfehlungskarten
// (z.B. Ergaenzende Produkte) enthaelt -- ein simples querySelector faende deren Badge zuerst, da
// der PDP-Hauptpreis selbst nie einen eigenen [data-tier-badge]-Slot rendert. Nur einen Treffer
// akzeptieren, dessen naechste Karten-Grenze root selbst ist (kein tiefer verschachtelter Slot).
function getTierBadgeSlot(div) {
  const root = div.closest('.product-card-wrapper, product-info, .simple-upsell__card, .stl-card');
  if (!root) return null;
  const slot = root.querySelector('[data-tier-badge]');
  if (slot && slot.closest('.product-card-wrapper, .simple-upsell__card, .stl-card') !== root) return null;
  return slot;
}

// DATORACODE - CFSN-664: .price__tier-line ist ein Geschwister-Element von .price
// (nicht darin verschachtelt) — daher ueber den gemeinsamen Elternknoten suchen, nicht per querySelector auf div selbst.
function getTierPriceLine(div) {
  return div.parentElement ? div.parentElement.querySelector('[data-tier-price-line]') : null;
}

// DATORACODE - CFSN-664: die Stueckpreis-Zeile markiert eindeutig eine Karten-Hauptpreis-Wurzel —
// nur dort gibt card-product.liquid show_tier_price_line mit (PDP-/Modal-Preise nicht).
function isTierPriceHost(div) {
  return !!getTierPriceLine(div);
}

// DATORACODE - CFSN-664: Karten in Flickity-Slidern (z.B. assets/collection-products-slider.js)
// berechnen ihre Zellenhoehen einmalig beim Aufbau und schneiden per overflow:hidden alles ab,
// was danach hoeher wird. Da unser Reveal per IntersectionObserver spaeter passiert als der
// Slider-Aufbau, muss der Slider nach jeder Sichtbarkeits-Aenderung neu vermessen werden.
// DATORACODE - CFSN-664: Flickity.resize() ist im Flickity-Quelltext ein No-Op, solange
// isAnimating/isDragging true ist. Kurz nach dem Slider-Aufbau ist meist noch das initiale Settle
// aktiv, wenn die (asynchrone) co2-Antwort zurueckkommt und die Zeile einblendet -- der direkte
// Aufruf verpufft dann. Direkter Versuch deckt den Ruhezustand ab, 'settle' faengt den
// Animations-Fall zuverlaessig ab (Muster wie filter-value-cards.js/simple-upsell-slider.js).
const tierSliderRetryPending = new WeakSet();

// DATORACODE - flickity.pkgd.min.js wird mehrfach eingebunden (theme.liquid + mehrere Sections).
// Jede Kopie fuehrt ihre eigene Instanz-Registry, deshalb liefert Flickity.data() hier keine oder
// eine fremde Instanz, deren resize() den echten Viewport nicht anfasst. Verlaesslich ist die
// .flkty der Slider-Komponente.
function getOwningFlickity(slider) {
  for (let el = slider; el && el !== document.body; el = el.parentElement) {
    const owned = el.flkty;
    if (owned && owned.element === slider && typeof owned.resize === 'function') return owned;
  }
  if (typeof Flickity === 'undefined' || typeof Flickity.data !== 'function') return null;
  const registered = Flickity.data(slider);
  if (registered && registered.element === slider && typeof registered.resize === 'function') {
    return registered;
  }
  return null;
}

function resizeOwningSlider(div) {
  // DATORACODE - CFSN-664 PR-Review: Control (kein Tier-Badge/-Zeile fuer diese Karte vorhanden)
  // soll gar keinen Resize ausloesen -- sonst laeuft bei jedem Swatch-Wechsel ein unnoetiger
  // Flickity-Resize, auch wenn das Feature fuer diese Karte/den Toggle gar nicht aktiv ist.
  if (!isTierPriceHost(div)) return;
  const slider = div.closest('.flickity-enabled');
  if (!slider) return;
  const flkty = getOwningFlickity(slider);
  if (!flkty) return;
  flkty.resize();
  // DATORACODE - CFSN-664 PR-Review: nur EIN 'settle'-Retry pro Flickity-Instanz gleichzeitig
  // registrieren -- sonst sammeln sich bei mehreren Karten-Updates (mehrere Swatch-Wechsel, mehrere
  // Karten im selben Slider) mehrere once('settle')-Listener an, die spaeter alle unabhaengig
  // voneinander resize() ausloesen.
  // DATORACODE - Schluessel ist die Instanz, nicht das Slider-Element: bei einem Breakpoint-Wechsel
  // ersetzen die Slider-Komponenten ihre Instanz, und destroy() verwirft deren Listener samt unserem
  // Retry-Callback. Eine Markierung am Element bliebe dann fuer immer stehen und wuerde den Retry der
  // neuen Instanz unterdruecken.
  if (tierSliderRetryPending.has(flkty)) return;
  tierSliderRetryPending.add(flkty);
  flkty.once('settle', () => {
    tierSliderRetryPending.delete(flkty);
    flkty.resize();
  });
}

function hideCardTierBadge(div) {
  const line = getTierPriceLine(div);
  if (!line) return; // Toggle aus / keine Karten-Hauptpreis-Wurzel
  // DATORACODE - CFSN-664 PR-Review: Token sofort invalidieren statt erst zu warten, bis die
  // naechste updateCardTierBadge()-Berechnung angestossen wird -- sonst kann ein noch laufender
  // aelterer co2-Request (z.B. vom vorherigen Swatch) nach diesem Hide noch aufloesen und einen
  // veralteten Preis/Badge kurz anzeigen.
  tierBadgeComputeToken.set(div, (tierBadgeComputeToken.get(div) || 0) + 1);
  const slot = getTierBadgeSlot(div);
  if (slot) slot.hidden = true;
  // Platz bleibt reserviert (nur visibility), Text wird geleert — kein alter Wert im A11y-Tree.
  line.classList.remove('price__tier-line--visible');
  const lineText = line.querySelector('[data-tier-price-line-text]');
  if (lineText) lineText.textContent = '';
  resizeOwningSlider(div);
}

function escapeTierText(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// DATORACODE - CFSN-664: formatPrice() kann Transcy-HTML (transcy-money-Span) enthalten -
// Template escapen, Preis als Sentinel durchschleusen und erst danach als vertrauenswuerdiges HTML
// einsetzen (Muster wie tiered-pricing-pdp.js/free-products.js), sonst zeigt der DE-Shop das
// Money-HTML als Text an statt es zu rendern.
function fillTierTemplate(template, quant, priceCents) {
  const PRICE = '___TIER_PRICE___';
  const withPlaceholder = String(template || '').replace('{{ quant }}', quant).replace('{{ price }}', PRICE);
  return escapeTierText(withPlaceholder).split(PRICE).join(formatPrice(priceCents));
}

const tierBadgeComputed = new WeakSet();
const tierBadgeComputeToken = new WeakMap();

// DATORACODE - CFSN-664: Menge x Stueckpreis der niedrigsten Staffel im Badge, Stueckpreis in der Zeile.
// Token pro Karte (analog computeToken in tiered-pricing-pdp.js) verwirft ueberholte Antworten bei
// schnellem Swatch-Wechsel — sonst koennte ein aelterer, noch laufender co2-Call spaeter aufloesen
// als ein neuerer und dessen Ergebnis ueberschreiben (AC: kein stehengebliebener alter Wert).
async function updateCardTierBadge(div) {
  const line = getTierPriceLine(div);
  if (!line) return; // Toggle aus / keine Karten-Hauptpreis-Wurzel (siehe isTierPriceHost)
  const slot = getTierBadgeSlot(div); // null, wenn die Karte bereits einen anderen Badge traegt
  tierBadgeComputed.add(div);
  const token = (tierBadgeComputeToken.get(div) || 0) + 1;
  tierBadgeComputeToken.set(div, token);
  if (typeof co2 === 'undefined') return;

  // CFSN-568 Discount-Badge hat Vorrang — unterdrueckt nur den Staffel-Badge (Bild-Slot).
  // Die Stueckpreis-Zeile ist davon unabhaengig und erscheint weiterhin, wenn eine Staffel
  // qualifiziert (AC: Zeile erscheint IMMER bei qualifizierender Staffel, nur der Badge nicht).
  const mirror = getImageDiscountMirror(div);
  let mirrorActive = !!(mirror && !mirror.hidden);
  if (mirrorActive && slot) slot.hidden = true;

  const pid = div.dataset.datoraProductId;
  const vid = div.dataset.datoraVariantId;
  const tags = div.dataset.datoraTags ? div.dataset.datoraTags.split(',') : [];
  const price = Number(div.dataset.datoraPrice);
  const compare = Number(div.dataset.datoraCompare) || 0;
  let variantTags = [];
  try {
    variantTags = JSON.parse(div.dataset.datoraVariantTags || '[]');
  } catch (e) {
    variantTags = [];
  }
  if (!(pid && vid && price)) {
    hideCardTierBadge(div);
    return;
  }

  try {
    const tiers = await computeCo2Tiers(Number(pid), Number(vid), tags, price, compare, variantTags);
    if (tierBadgeComputeToken.get(div) !== token) return; // ueberholt durch einen neueren Aufruf

    if (!tiers.length) {
      hideCardTierBadge(div);
      return;
    }
    // DATORACODE - CFSN-664 PR-Review: Mirror-Zustand kann sich waehrend des asynchronen
    // co2-Requests geaendert haben (Bild-Discount-Badge kann inzwischen aktiv geworden sein) --
    // frisch pruefen statt den Schnappschuss von vor dem Request weiterzuverwenden.
    mirrorActive = !!(mirror && !mirror.hidden);
    if (mirrorActive && slot) slot.hidden = true;
    const tier = tiers[0]; // niedrigste qualifizierende Staffel
    const strings = window.themeVariables?.strings || {};
    if (slot && !mirrorActive) {
      const text = slot.querySelector('[data-tier-badge-text]');
      if (text) {
        text.innerHTML = fillTierTemplate(strings.tierBadgeText, tier.quant, tier.quant * tier.unitPriceCents);
      }
      slot.hidden = false;
    }
    const lineText = line.querySelector('[data-tier-price-line-text]');
    if (lineText) {
      lineText.innerHTML = fillTierTemplate(strings.tierUnitText, tier.quant, tier.unitPriceCents);
    }
    line.classList.add('price__tier-line--visible');
    resizeOwningSlider(div);
  } catch (error) {
    if (tierBadgeComputeToken.get(div) !== token) return; // ueberholt durch einen neueren Aufruf
    console.error('[datora] tier badge error:', error);
    hideCardTierBadge(div);
  }
}

const tierBadgeObserved = new WeakSet();
let tierBadgeIO = null;

// DATORACODE - CFSN-664: lazy per IntersectionObserver, damit nicht jede Karte im Grid sofort
// einen co2-Call ausloest. Kein Theme-Vorbild fuer IO bei Datora-Preisen, aber im Ticket verlangt.
function observeCardTierBadges(scope) {
  scope = scope || document;
  if (!tierBadgeIO) {
    tierBadgeIO = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          updateCardTierBadge(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '200px' }
    );
  }
  // DATORACODE - CFSN-664: bei ausgeschaltetem A/B-Toggle rendert Liquid gar keine
  // [data-tier-price-line]-Slots -- ein Treffer hier spart die Karten-fuer-Karte-Pruefung unten komplett.
  if (!scope.querySelector('[data-tier-price-line]')) return;
  scope.querySelectorAll('[data-datora-product-id]').forEach(function (div) {
    if (tierBadgeObserved.has(div)) return;
    if (!isTierPriceHost(div)) return;
    tierBadgeObserved.add(div);
    tierBadgeIO.observe(div);
  });
}

// Rabattcode-Aenderungen koennen die Staffel-Qualifikation aendern — bereits berechnete Karten
// (auch ausserhalb des Sichtfelds) neu rechnen, analog zur PDP-Box.
// DATORACODE - CFSN-664: Scope-Parameter statt fest document -- sonst loest z.B. ein einzelner
// Swatch-Wechsel (scope = eine Karte) eine seitenweite Neuberechnung aller bereits berechneten
// Staffel-Badges aus, statt nur der betroffenen Karte(n).
function recomputeCardTierBadges(scope) {
  scope = scope || document;
  scope.querySelectorAll('[data-datora-product-id]').forEach(function (div) {
    if (tierBadgeComputed.has(div)) updateCardTierBadge(div);
  });
}

// ---------------------------------------------------------------------------
// Dawn theme integration
// ---------------------------------------------------------------------------

// DATORACODE - Expose for use in shop-the-look-slider.js
window.datoraUpdatePrices = updateProductGridDiscounts;

// Cart refresh via Dawn pub/sub (global.js bridge dispatches cart.update for co2)
function refreshCartAndPrices() {
  fetch(window.Shopify?.routes?.root + 'cart.js', { cache: 'reload' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'datora', cartData: cart });
    })
    .catch(function (e) {
      console.error('[datora] cart refresh error:', e);
    });
}

// Dawn pub/sub event subscriptions

subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
  window.dispatchEvent(new CustomEvent('cart.update', { detail: { cart: event.cartData } }));
  if (typeof restoreDiscountState === 'function') restoreDiscountState();
});

subscribe(PUB_SUB_EVENTS.variantChange, function () {
  if (typeof co2 === 'undefined') return;
  requestAnimationFrame(function () {
    updateProductGridDiscounts();
  });
});

window.addEventListener('co2.cart.initialized', function() {
  // DATORACODE - CFSN-664: der Staffel-Badge-Recompute laeuft jetzt zentral am Ende von
  // updateProductGridDiscounts() selbst, kein eigener .then()-Nachlauf mehr noetig
  updateProductGridDiscounts().catch(function (e) {
    console.error('[datora] grid discount error:', e);
  });
  restoreDiscountState();
});

let autoDiscountChecked = false;
window.addEventListener('co2.cart.initialized', async function() {
  if (autoDiscountChecked) return;
  autoDiscountChecked = true;
  const settings = window.themeVariables?.settings;
  if (!settings?.autoDiscountEnabled || !settings?.autoDiscountCode) return;
  if (typeof co2 === 'undefined') return;
  const currentCode = await co2.getDiscountCode();
  if (currentCode) return;
  const success = await co2.setDiscountCode(settings.autoDiscountCode);
  if (success) {
    refreshCartAndPrices();
  }
});

window.datoraUpdatePrices = updateProductGridDiscounts;
